import { QuestionTypeChip } from '@exam-management/components';
import { Chip, Divider, Flex, Text } from '@shared/components';
interface ChapterInfoSectionProps {
  title: string;
  qSource: string;
  questionType?: 'single' | 'item-set';
}

export default function ChapterInfoSection(props: Readonly<ChapterInfoSectionProps>) {
  const { title, qSource, questionType } = props;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(4),
        backgroundColor: theme.palette.grey[50],
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[200]}`,
        p: theme.spacing(4),
      })}
    >
      <Flex sx={{ justifyContent: 'space-between' }}>
        <Text variant='body1Semibold'>{title}</Text>
        <Chip
          label={`QSource: ${qSource}`}
          sx={(theme) => ({
            backgroundColor: theme.palette.grey[200],
            border: `1px solid ${theme.palette.grey[300]}`,
            maxHeight: '24px',
          })}
        />
      </Flex>
      <Divider />
      <Flex sx={{ flexDirection: 'row', gap: (theme) => theme.spacing(2) }}>
        <Text variant='body2'>Question Type:</Text>
        <QuestionTypeChip type={questionType ?? 'single'} />
      </Flex>
    </Flex>
  );
}
